import { formatHours, formatMoney } from "../builder/format";
import { billingLabel, productTotals, type ChildProduct } from "./childExtras";

interface Props {
  products: ChildProduct[];
  currency: string;
}

// Product lines on the change request project, totalled per billing
// frequency so one-time and recurring amounts aren't added together.
const ChildProductsTable = ({ products, currency }: Props) => {
  if (products.length === 0) return null;
  return (
    <table className="table table-sm">
      <thead>
        <tr>
          <th>Name</th>
          <th>Quantity</th>
          <th>Unit price</th>
          <th>Price</th>
          <th>Billing</th>
        </tr>
      </thead>
      <tbody>
        {products.map((p) => (
          <tr key={p.id}>
            <td>{p.name}</td>
            <td>{formatHours(p.quantity)}</td>
            <td>{formatMoney(p.unitPrice, currency)}</td>
            <td>{formatMoney(p.price, currency, true)}</td>
            <td>{billingLabel(p.billingFrequency)}</td>
          </tr>
        ))}
        {productTotals(products).map((t) => (
          <tr key={t.billingFrequency} className="font-weight-bold">
            <td colSpan={3}>{`Total (${t.label})`}</td>
            <td>{formatMoney(t.total, currency, true)}</td>
            <td />
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ChildProductsTable;
